<template>
  <!-- 轨迹同步视频 组件 -->
  <div ref="videoBox" class="video-play-main" v-if="videoShow">
    <div class="video-play-title">
      <div class="name">
        <span :title="videoName">
          {{ videoName | ellipsis }}
        </span>
        <span class="fz12 time">
          <!-- {{ videoTime }} -->
        </span>
      </div>
      <i slot="reference" class="imp-icon icon20"></i>
      <span>{{ $t('importantH') }}：</span>
      <el-checkbox v-model="impFlag" class="importantCheck" @change="changeImpFlag"></el-checkbox>
      <i class="speed-back-icon icon20" title="慢放" @click="changeSpeedLow"></i>
      <i class="speed-to-icon icon20" :title="$t('fastForward')" @click="changeSpeedHight"></i>
      <span>×</span>
      <span>{{ playbackRate }}</span>
      <!-- <span class="ml10">轨迹：</span>
      <input value="true" type="checkbox" class="importantCheck" /> -->
      <div class="resolution">
        <span :class="[isLowResolution ? 'resolution-low hightLight' : 'resolution-low']" @click="trggerResolution">
          {{ $t('fluent') }}
        </span>
        <span
          :class="[!isLowResolution ? 'resolution-hight hightLight' : 'resolution-hight']"
          @click="trggerResolution"
        >
          {{ $t('highDefinition') }}
        </span>
      </div>
      <div class="close" @click="returnList">X</div>
    </div>
    <div class="video-play-contain">
      <video
        :src="videoSrcPlay"
        autoplay="autoplay"
        class="video-player"
        ref="trailVideo"
        controls="controls"
        @timeupdate="timeupdate"
        id="trailPlay"
      ></video>
    </div>
  </div>
</template>

<script>
import { isImportantFlag } from '@/api/log/video'
import { success, PrefixInteger } from '@/api/common'
export default {
  props: {
    videoSrc: {
      type: Object / Array,
    },
    index: {
      type: Number,
    },
    videoShow: {
      type: Boolean,
      default: false,
    },
    videoSecond: {
      type: Number,
    },
  },
  data() {
    return {
      isLowResolution: true,
      playbackRate: 1,
      playbackRateLevel: 1,
      // 拷贝后的index 用于修改下一个视频
      cpIndex: '',
      videoSrcArrCopy: '',
      videoSrcPlay: '',
      videoInfo: {
        fileSize: '',
        videoBitRate: '',
        videoFrameRate: '',
        videoWidth: '',
        videoHeight: '',
      },
      videoName: '',
      impFlag: false,
      // 展示的播放状态，不代表视频真的在播放，video.paused可以获取真实的状态
      isVideoPlay: true,
      playedTime: 0,
      muted: true,
      isFullScreen: false,
    }
  },
  computed: {
    videoTime() {
      if (this.videoSrcArrCopy) {
        return this.videoSrcArrCopy.endTimestamp
      } else {
        return ''
      }
    },
  },
  methods: {
    changeImpFlag(val) {
      console.log(val, 'val')

      let param = {
        importantFlag: val,
        logTimestamp: this.videoSrcArrCopy.logTimestamp,
        type: 1,
        userId: this.videoSrcArrCopy.userId,
      }
      isImportantFlag(param).then(res => {
        console.log(res)
        if (res.state === 0) {
          success(this.$t('SettingSucceeded'))
          this.impFlag = val
        }
      })
    },
    returnList() {
      this.$emit('trailVideo')
      this.$emit('update:videoShow', false)
      this.playbackRate = 1
    },
    // 切换分辨率
    trggerResolution() {
      console.log(' this.isLowResolution', this.isLowResolution, this.videoSrcArrCopy)
      this.isLowResolution = !this.isLowResolution
      if (this.isLowResolution) {
        if (this.videoSrcArrCopy) {
          if (this.videoSrcArrCopy.mediaLowUrl) {
            this.videoSrcPlay = this.videoSrcArrCopy.mediaLowUrl
          }
        }
      } else {
        this.videoSrcPlay = this.videoSrcArrCopy.mediaUrl
      }
    },

    // 快进
    changeSpeedHight() {
      if (this.playbackRateLevel !== 5) {
        this.playbackRateLevel = this.playbackRateLevel + 1
      }
      switch (this.playbackRateLevel) {
        case 1:
          this.playbackRate = 1
          break
        case 2:
          this.playbackRate = 1.5
          break
        case 3:
          this.playbackRate = 2
          break
        case 4:
          this.playbackRate = 4
          break
        case 5:
          this.playbackRate = 8
          break
      }
      this.$refs.video.playbackRate = this.playbackRate
    },
    // 慢放
    changeSpeedLow() {
      if (this.playbackRateLevel !== 0) {
        this.playbackRateLevel = this.playbackRateLevel - 1
      }
      switch (this.playbackRateLevel) {
        case 0:
          this.playbackRate = 0.5
          break
        case 1:
          this.playbackRate = 1
          break
        case 2:
          this.playbackRate = 1.5
          break
        case 3:
          this.playbackRate = 2
          break
        case 4:
          this.playbackRate = 4
          break
        case 5:
          this.playbackRate = 8
          break
      }
      this.$refs.video.playbackRate = this.playbackRate
    },
    // 视频播放时间更新
    timeupdate() {
      if (this.$refs.video) {
        let time = this.$refs.video.currentTime
        var hour = Math.floor(time / 3600)
        var minute = Math.floor((time % 3600) / 60)
        var second = Math.floor(time % 60)
        this.playedTime = PrefixInteger(hour, 2) + ':' + PrefixInteger(minute, 2) + ':' + PrefixInteger(second, 2)
      }
    },
  },
  mounted() {
    // 自动播放下一条
    let that = this
    if (this.$refs.video) {
      this.$refs.video.onended = function() {
        if (that.cpIndex >= that.videoSrcArrCopy.length - 1) {
          that.cpIndex = 0
        } else {
          that.cpIndex += 1
        }
        that.playbackRate = 1
      }
    }
  },
  destroyed() {
    this.returnList()
  },
  watch: {
    index(val, oal) {
      this.cpIndex = this.index
      console.log(this.index)

      if (this.videoSrcArrCopy.length > 0) {
        this.videoSrcPlay = this.videoSrcArrCopy[this.index].mediaUrl
      }
    },
    cpIndex() {
      if (this.videoSrcArrCopy[this.cpIndex]) {
        this.videoSrcPlay = this.videoSrcArrCopy[this.cpIndex].mediaUrl
      }
    },
    videoSrc: {
      handler(newval, old) {
        this.videoName = newval.userName
        this.videoSrcPlay = newval.mediaUrl
        this.videoSrcArrCopy = newval
      },
      immediate: true,
    },
    videoSecond: {
      handler(newval, old) {
        setTimeout(() => {
          let myvideo = document.getElementById('trailPlay')
          if (myvideo !== null) {
            myvideo.currentTime = newval
          }
        }, 1000)
      },
      immediate: true,
    },
  },
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~@/style/mixin.styl'

.video-play-main
  width 100%
  height 100%
  .video-play-title
    display flex
    align-items center
    padding 8px 0px
    background var(--trail-container-bg)
    .name
      display flex
      flex-direction column
      margin-left 5px
      .time
        color var(--video-time-color)
    .importantCheck
      margin-right 10px
    .back-icon
      cursor pointer
      margin-left 10px
      bg-image('~@/icon/ic_back.png')
    .imp-icon
      margin-left 20px
      margin-right 10px
      bg-image('~@/icon/imp.png')
    .speed-to-icon
      cursor pointer
      margin 0 5px
      bg-image('~@/icon/speed-to.png')
    .speed-back-icon
      cursor pointer
      margin 0 5px
      bg-image('~@/icon/speed-back.png')
    .resolution
      margin-left 20px
      .resolution-low
        cursor pointer
        padding 2px 6px
        border-bottom-left-radius 8px
        border-top-left-radius 8px
        border 1px solid #D4D4D4
      .resolution-hight
        cursor pointer
        padding 2px 6px
        border 1px solid #D4D4D4
        border-bottom-right-radius 8px
        border-top-right-radius 8px
      .hightLight
        background var(--video-resolution-bg)
        color var(--video-resolution-color)
    .close
      position absolute
      right 5px
      top 5px
      width 17px
      height 17px
      cursor pointer
  .video-play-contain
    position relative
    .video-player
      width 100%
      height 250px; /* no */
      object-fit fill
    .video_controller
      position absolute
      bottom 0
      left 0
      background-color rgba(0, 0, 0, 0.5)
      width 100%
      height 33px
      line-height 33px
      z-index 1000
      color #fff
      letter-spacing 1px
      .video_pause
        width 23px
        height 23px
        float left
        left 10px
        top 5px
        position absolute
        cursor pointer
      .progress_time
        height 3px
        width 74%
        position absolute
        left 50px
        top 0
      .video_progress
        height 3px
        width calc(100% - 60px) /* no */
        float right
        margin-top 15px
      .video_time
        font-size 12px
        color white
        width 60px /* no */
        margin-top 0px
        float left
      .video_volume
        cursor pointer
        width 23px
        height 23px
        position absolute
        right 38px
        top 5px
      .full_btn
        width 30px
        height 30px
        position absolute
        right 5px
        top 3px
        cursor pointer
        bottom 26px
</style>
